import { render, staticRenderFns } from "./SiatPraticheListComponent.vue?vue&type=template&id=4eb08f2b&scoped=true"
import script from "./SiatPraticheListComponent.vue?vue&type=script&lang=js"
export * from "./SiatPraticheListComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatPraticheListComponent.vue?vue&type=style&index=0&id=4eb08f2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb08f2b",
  null
  
)

export default component.exports